module.exports = __webpack_public_path__ + "media/images/business/illust-case-02-8891852e4118059433dc381fa49d97a0.svg";